import { createAsyncThunk } from '@reduxjs/toolkit'
import SystemSetting from './system-setting-model'
import {
  delete_systemSetting,
  load_systemSettings,
  store_systemSetting,
} from './systemSetting-service'

export const LoadSystemSettingsAsync = createAsyncThunk<any, any>(
  'composer/load/systemSetting',
  async (params: { uid: string }) => {
    return await load_systemSettings(params)
  },
)

export const CreateSystemSettingAsync = createAsyncThunk<any, any>(
  'composer/create/systemSetting',
  async (params: SystemSetting) => {
    return await store_systemSetting(params)
  },
)

export const DeleteSystemSettingAsync = createAsyncThunk<any, any>(
  'composer/delete/systemSetting',
  async (params) => {
    return await delete_systemSetting(params)
  },
)
